import React from "react";
import { Table } from "antd";
import axios from "axios";

import Tags from "./Tags";
import { SAMPLES_API } from "../../constants/Api";

const columns = [
  {
    title: " ",
    dataIndex: "state",
    key: "state",
    width: 32,
    render: () => <img src="/img/eye.svg" alt="" />
  },
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    defaultSortOrder: "descend",
    width: 106,
    sorter: (a, b) => b.id - a.id
  },
  {
    title: "Barcode",
    dataIndex: "barcode",
    key: "barcode",
    width: 108,
    sorter: (a, b) => b.barcode.localeCompare(a.barcode)
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: 188,
    sorter: (a, b) => b.description.localeCompare(a.description)
  },
  {
    title: "Tags",
    dataIndex: "tags",
    key: "tags",
    width: 68,
    render: () => <Tags />
  },
  {
    title: "Display",
    dataIndex: "display",
    key: "display",
    width: 148,
    sorter: (a, b) => b.display.localeCompare(a.display)
  },
  {
    title: "Subject ID",
    dataIndex: "subjectId",
    key: "subjectId",
    width: 142,
    sorter: (a, b) => b.subjectId.localeCompare(a.subjectId)
  },
  {
    title: "Form",
    dataIndex: "form",
    key: "form",
    width: 150,
    sorter: (a, b) => b.form.localeCompare(a.form)
  },
  {
    title: "Uploaded",
    dataIndex: "uploaded",
    key: "uploaded",
    width: 160,
    sorter: (a, b) => b.uploaded.localeCompare(a.uploaded)
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 98,
    sorter: (a, b) => b.status.localeCompare(a.status)
  },
  {
    title: "Application",
    dataIndex: "application",
    key: "application",
    width: 112,
    sorter: (a, b) => b.application.localeCompare(a.application)
  }
];

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(
      `selectedRowKeys: ${selectedRowKeys}`,
      "selectedRows: ",
      selectedRows
    );
  },
  getCheckboxProps: record => ({})
};

class Grid extends React.Component {
  constructor() {
    super();
    this.state = {
      data: null,
      loading: true
    };
  }

  componentDidMount() {
    this.setState({ loading: true }, () => {
      axios
        .get(SAMPLES_API)
        .then(response => {
          this.setState({ data: response.data, loading: false });
        })
        .catch(error => {
          console.log(error);
          this.setState({ loading: false });
        });
    });
  }

  render() {
    const { data, loading } = this.state;
    return (
      <div className="grid">
        <div className="grid__head">
          <div className="grid__title">Showing 94</div>
          <div className="grid__filters">
            Filters applied <span className="grid__counter">0</span>
          </div>
        </div>
        <div className="grid__body">
          <div className="grid__scroll">
            <Table
              className="grid__table"
              rowSelection={rowSelection}
              columns={columns}
              dataSource={data}
              pagination={false}
              loading={loading}
              size="small"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Grid;
